/** @jsxImportSource @emotion/react */
import { createContext, useContext, useReducer } from 'react'
import { UIState, UIAction } from './types'
import { uiReducer, initialUIState } from './reducer'

interface UIContextValue {
  state: UIState
  dispatch: React.Dispatch<UIAction>
}

const UIContext = createContext<UIContextValue | null>(null)

interface UIProviderProps {
  children: React.ReactNode
}

export function UIProvider({ children }: UIProviderProps) {
  const [state, dispatch] = useReducer(uiReducer, initialUIState)

  return (
    <UIContext.Provider value={{ state, dispatch }}>
      {children}
    </UIContext.Provider>
  )
}

export function useUIContext(): UIContextValue {
  const context = useContext(UIContext)
  if (!context) {
    throw new Error('useUIContext must be used within a UIProvider')
  }
  return context
}
